var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _c(
        "tr",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          on: {
            click: function($event) {
              return _vm.$emit("select-item", _vm.item.id)
            }
          }
        },
        [
          _c("td", [
            _c(
              "span",
              [
                _vm._l(_vm.level, function(index) {
                  return _c("i", {
                    key: index,
                    staticClass: "level fas fa-caret-up type-indicator"
                  })
                }),
                _vm._v(" "),
                _vm.hasChildren
                  ? _c(
                      "a",
                      {
                        staticClass: "show-children type-indicator",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.showChildren = !_vm.showChildren
                          }
                        }
                      },
                      [
                        !_vm.showChildren
                          ? _c("i", { staticClass: "fas fa-angle-down" })
                          : _c("i", { staticClass: "fas fa-angle-up" })
                      ]
                    )
                  : _vm.level === 0
                  ? _c("span", { staticClass: "type-indicator" }, [
                      _vm._v(
                        "\n                         \n                    "
                      )
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n                    \n                    " +
                    _vm._s(_vm.item.name) +
                    "\n                "
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.world))])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.division))])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.description))])]),
          _vm._v(" "),
          _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.version))])]),
          _vm._v(" "),
          _c("td", [
            _vm.item.isPublished
              ? _c("span", [_c("i", { staticClass: "fas fa-check" })])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: {
                  click: function($event) {
                    return _vm.$emit("statistics", _vm.item)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-project-diagram" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: {
                  click: function($event) {
                    return _vm.$emit("edit", _vm.item)
                  }
                }
              },
              [
                _vm.canWrite
                  ? _c("i", { staticClass: "fas fa-edit" })
                  : _c("i", { staticClass: "fas fa-eye" })
              ]
            ),
            _vm._v(" "),
            _vm.canWrite
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: {
                      click: function($event) {
                        return _vm.$emit("clone", _vm.item)
                      }
                    }
                  },
                  [_c("i", { staticClass: "far fa-clone" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasDeletePermission
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: {
                      click: function($event) {
                        return _vm.$emit("delete", _vm.item)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-trash" })]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.item.children, function(child) {
        return _c("DataRowChild", {
          key: child.id,
          attrs: {
            item: child,
            label: _vm.label,
            level: _vm.level + 1,
            visible: _vm.showChildren && child.visible
          },
          on: {
            "select-item": function($event) {
              return _vm.$emit("select-item", $event)
            },
            clone: function($event) {
              return _vm.$emit("clone", $event)
            },
            delete: function($event) {
              return _vm.$emit("delete", $event)
            },
            edit: function($event) {
              return _vm.$emit("edit", $event)
            },
            statistics: function($event) {
              return _vm.$emit("statistics", $event)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }